import {Validator} from 'vee-validate';

const initPasswordRules = (errorFunction) => {
  Validator.extend('checkPassword', {
    getMessage: errorFunction,
    validate: (value) => {
      // This regular expression defines a password is at least 8 characters long, no spaces, and must contain one each of the following:
      // one digit (0-9), one lowercase letter (a-z), one uppercase letter (A-Z), and one special character (~!@$%^&*()_+`-=[]{}\|<>?,./"'#:;).
      let regex = new RegExp('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^\\W])(?=\\S+$).{8,}$');
      return regex.test(value);
    },
  });
};

export {initPasswordRules};
